"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _datepicker_compact_props = _interopRequireDefault(require("./datepicker_compact_props"));

var _datepicker_props = require("./datepicker_props");

var _index = require("./utils/index");

var _data = require("./config/data");

var _date_play_component = _interopRequireDefault(require("./component/date_play_component"));

var _single_date_component = _interopRequireDefault(require("./component/single_date_component"));

var _range_date_component = _interopRequireDefault(require("./component/range_date_component"));

var _use_portal_component = _interopRequireDefault(require("./component/use_portal_component"));

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

var _index2 = require("./config/index");

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var DatePicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DatePicker, _PureComponent);

  function DatePicker(_props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, _props));
    var props = (0, _datepicker_compact_props["default"])(_props); // 语言文案

    _this.locale = (0, _spauiUtils.objectAssign)({}, _index2.defaultLocale, props.locale); // 如果自己传了当前时间，默认就都用这个当前时间了

    if (props.currentTime) {
      _this.currentTime = new Date(props.currentTime);
    } else {
      _this.currentTime = new Date();
    }

    _this._insideClick = false;
    _this._inputDateTriggerBlur = false;

    _this.nullList();

    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.documentClick = _this.documentClick.bind(_assertThisInitialized(_this));
    _this.setDropDownPanelPositionWhenUsePortal = _this.setDropDownPanelPositionWhenUsePortal.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleRealtimeChange = _this.handleRealtimeChange.bind(_assertThisInitialized(_this));
    _this.handleSingleChange = _this.handleSingleChange.bind(_assertThisInitialized(_this));
    _this.handleRangeChange = _this.handleRangeChange.bind(_assertThisInitialized(_this));
    _this.handleYearAndMonthChange = _this.handleYearAndMonthChange.bind(_assertThisInitialized(_this));
    _this.triggerChange = _this.triggerChange.bind(_assertThisInitialized(_this));
    _this.isUnlimitedDate = _this.isUnlimitedDate.bind(_assertThisInitialized(_this));
    _this.getDateValue = _this.getDateValue.bind(_assertThisInitialized(_this));
    _this.state = _objectSpread({}, _this.getDataByPropsDate(props, undefined, 'init'), {
      empty: false,
      // 是否被临时清空
      open: props.open || false
    });
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDropDownPanelPositionWhenUsePortal();
      this.updateWindowResize();
      this.updateDocumentClick();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      var theNextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var thisProps = (0, _datepicker_compact_props["default"])(this.props);
      var nextProps = (0, _datepicker_compact_props["default"])(theNextProps); // 语言文案

      this.locale = (0, _spauiUtils.objectAssign)({}, _index2.defaultLocale, nextProps.locale); // open一直

      if (!(0, _spauiUtils.isUndefined)(nextProps.open)) {
        this.setState({
          open: nextProps.open
        });
        this._inputDateTriggerBlur = false;
      } // 有数据变更，那就不是清空啦


      this.setState({
        empty: false
      }); // 数据有变更的时候，重新获取数据

      if (thisProps.date !== nextProps.date) {
        this.setState(_objectSpread({}, this.getDataByPropsDate(nextProps, 'single')));
      }

      if (thisProps.startDate !== nextProps.startDate) {
        this.setState(_objectSpread({}, this.getDataByPropsDate(nextProps, 'start')));
      }

      if (thisProps.endDate !== nextProps.endDate) {
        this.setState(_objectSpread({}, this.getDataByPropsDate(nextProps, 'end')));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDropDownPanelPositionWhenUsePortal();
      this.updateWindowResize();
      this.updateDocumentClick();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeWindowResize();
      this.removeDocumentClick();
      this.nullList();
    } // 声明以及一些引用的回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.domRef = null;
      this.dropdownRef = null;
      this.datePlayRef = null;
      this.datePlayElementRef = null;
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _compactProps = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps$classNa = _compactProps.classNameMap,
          classNameMap = _compactProps$classNa === void 0 ? {} : _compactProps$classNa;

      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        datepicker: this.domRef || null
      };
    }
  }, {
    key: "updateDocumentClick",
    value: function updateDocumentClick() {
      var open = this.state.open; // open为false的时候进行回收，this.haveDocumentClick是为了避免多次监听

      if (open && !this.haveDocumentClick) {
        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
          document.addEventListener('click', this.documentClick);
        }

        this.haveDocumentClick = true;
      } else if (!open) {
        this.removeDocumentClick();
      }
    }
  }, {
    key: "removeDocumentClick",
    value: function removeDocumentClick() {
      if (this.haveDocumentClick) {
        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
          document.removeEventListener('click', this.documentClick);
        }

        this.haveDocumentClick = false;
        this._insideClick = false;
      }
    } // 点击空白处

  }, {
    key: "documentClick",
    value: function documentClick(event) {
      var open = this.state.open;

      if (this.domRef) {
        if (open && !this._insideClick) {
          if (this._inputDateTriggerBlur) {
            // 触发下变更
            this.datePlayRef.triggerChange(event);
            this._inputDateTriggerBlur = false;
          }

          this.handleOpen(event);
        }

        this._insideClick = false;
      }
    } // 打开的时候监听resize，关闭去除，以便提高性能

  }, {
    key: "updateWindowResize",
    value: function updateWindowResize() {
      var open = this.state.open; // 需要回收，this.haveAddWindowResize避免多次监听

      if (open && !this.haveAddWindowResize) {
        (0, _index.addResize)(this.setDropDownPanelPositionWhenUsePortal);
        this.haveAddWindowResize = true;
      } else if (!open) {
        this.removeWindowResize();
      }
    }
  }, {
    key: "removeWindowResize",
    value: function removeWindowResize() {
      if (this.haveAddWindowResize) {
        (0, _index.removeResize)(this.setDropDownPanelPositionWhenUsePortal);
        this.haveAddWindowResize = false;
      }
    } // 更新展开面板的位置信息

  }, {
    key: "setDropDownPanelPositionWhenUsePortal",
    value: function setDropDownPanelPositionWhenUsePortal() {
      var _compactProps2 = (0, _datepicker_compact_props["default"])(this.props),
          mountTarget = _compactProps2.mountTarget,
          autoPlacementBasic = _compactProps2.autoPlacementBasic,
          verticalPosition = _compactProps2.verticalPosition,
          positionDeviation = _compactProps2.positionDeviation;

      var dropDownStyle = {};
      var datepickerRect = {};
      var scrollTop = 0;
      var targetRect = {};
      var top = 0;
      var left = 0;

      if (!(this.domRef && this.dropdownRef)) {
        return;
      }

      if (mountTarget === 'body' || _typeof(mountTarget) === 'object') {
        // 获取下拉面板的位置
        dropDownStyle = this.getDropDownStyle(); // 组件的位置信息

        datepickerRect = this.domRef.getBoundingClientRect(); // 挂在对象的滚动条高度

        scrollTop = (0, _spauiUtils.getScrollTop)(mountTarget);

        if (mountTarget === 'body') {
          // 下拉面板现在自己的位置+组件在页面的位置
          top = (0, _index.toInt)(dropDownStyle.top) + datepickerRect.top + scrollTop;
          left = (0, _index.toInt)(dropDownStyle.left) + datepickerRect.left;
        } else {
          targetRect = mountTarget.getBoundingClientRect(); // 已经在target内，所以要减去target本身的left,top

          top = (0, _index.toInt)(dropDownStyle.top) + datepickerRect.top - targetRect.top + scrollTop;
          left = (0, _index.toInt)(dropDownStyle.left) + datepickerRect.left - targetRect.left;
        }

        this.dropdownRef.style.top = "".concat(top, "px");
        this.dropdownRef.style.left = "".concat(left, "px");
      } else if (mountTarget === 'component') {
        // 自动展开的话要看看是否要调整下展开的方向
        if (verticalPosition === 'auto' && this.datePlayElementRef) {
          var documentHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
          var finalPlacement = ''; // 获取组件的top位置

          var selectWrapperTop = (0, _index.getElementTop)(this.datePlayElementRef); // 获取展开面板的高度

          var dropHeight = this.dropdownRef.getBoundingClientRect().height; // 如果自动展开的方向是要依据窗口的位置而不是文档流

          if (autoPlacementBasic === 'window') {
            documentHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            selectWrapperTop = (0, _index.getElementViewTop)(this.datePlayElementRef);
          } // 展开下拉面板后碰到或超过页面的高度了


          if (documentHeight <= selectWrapperTop + dropHeight) {
            finalPlacement = 'top';
          } else {
            finalPlacement = 'bottom';
          }

          if (finalPlacement === 'top') {
            this.dropdownRef.style.bottom = "".concat(positionDeviation.bottom || 0, "px");
            this.dropdownRef.style.top = 'auto';
          }
        }
      }
    } // week onChange事件

  }, {
    key: "triggerWeekChange",
    value: function triggerWeekChange(event, onChange, getReturnDate, startDate, endDate, firstDayOfWeek, endDayOfWeek, disableWeekDays) {
      var rangeWeekDays = (0, _index.getRangeWeekDays)(startDate, endDate, firstDayOfWeek, endDayOfWeek, false, disableWeekDays);
      var selectWeek = {
        // 返回选择周信息
        text: "".concat((0, _index.getWeekOfYearByDate)(startDate, firstDayOfWeek, endDayOfWeek), "\u5468\u81F3").concat((0, _index.getWeekOfYearByDate)(endDate, firstDayOfWeek, endDayOfWeek), "\u5468"),
        // 返回选择周内所有的天数
        value: {
          // 全部天数，包含不可选日期
          all: (0, _index.uniqueArray)((0, _index.getRangeWeekDays)(startDate, endDate, firstDayOfWeek, endDayOfWeek)),
          part: (0, _index.uniqueArray)(rangeWeekDays)
        }
      };
      onChange(event, getReturnDate(startDate, 'startDate'), getReturnDate(endDate, 'endDate'), selectWeek);
    } // 触发日期变更函数

  }, {
    key: "triggerChange",
    value: function triggerChange(event) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var dataMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _compactProps3 = (0, _datepicker_compact_props["default"])(this.props),
          onChange = _compactProps3.onChange,
          format = _compactProps3.format,
          propsType = _compactProps3.type,
          propsDate = _compactProps3.date,
          propsStartDate = _compactProps3.startDate,
          propsEndDate = _compactProps3.endDate,
          picker = _compactProps3.picker,
          _compactProps3$firstD = _compactProps3.firstDayOfWeek,
          firstDayOfWeek = _compactProps3$firstD === void 0 ? 1 : _compactProps3$firstD,
          endDayOfWeek = _compactProps3.endDayOfWeek,
          fixedNumber = _compactProps3.fixedNumber,
          unlimitedDateValue = _compactProps3.unlimitedDateValue,
          startDateCanBeUnlimited = _compactProps3.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _compactProps3.endDateCanBeUnlimited,
          _compactProps3$useTim = _compactProps3.useTimeStamp,
          useTimeStamp = _compactProps3$useTim === void 0 ? false : _compactProps3$useTim,
          _compactProps3$timePi = _compactProps3.timePicker,
          timePicker = _compactProps3$timePi === void 0 ? false : _compactProps3$timePi;

      var _dataMap$data = dataMap.data,
          data = _dataMap$data === void 0 ? null : _dataMap$data,
          _dataMap$startData = dataMap.startData,
          startData = _dataMap$startData === void 0 ? null : _dataMap$startData,
          _dataMap$endData = dataMap.endData,
          endData = _dataMap$endData === void 0 ? null : _dataMap$endData;

      var _this$getOptionalTime = this.getOptionalTime(),
          _this$getOptionalTime2 = _this$getOptionalTime.optionalStartDateData,
          optionalStartDateData = _this$getOptionalTime2 === void 0 ? {} : _this$getOptionalTime2,
          _this$getOptionalTime3 = _this$getOptionalTime.optionalEndDateData,
          optionalEndDateData = _this$getOptionalTime3 === void 0 ? {} : _this$getOptionalTime3;

      var optionalStartYear = optionalStartDateData.year,
          optionalStartMonth = optionalStartDateData.month,
          optionalStartDate = optionalStartDateData.date;
      var optionalEndYear = optionalEndDateData.year,
          optionalEndMonth = optionalEndDateData.month,
          optionalEndDate = optionalEndDateData.date;
      var minDate = (0, _index.formatDate)(new Date(optionalStartYear, optionalStartMonth, optionalStartDate));
      var maxDate = (0, _index.formatDate)(new Date(optionalEndYear, optionalEndMonth, optionalEndDate)); // 检验下是否需要触发change，如果数据没有变更就不响应

      var needTriggerChange = function needTriggerChange(startDate, endDate) {
        var result = true;

        if (propsType === 'single') {
          if (propsDate === startDate) {
            result = false;
          }
        } else {
          if (propsStartDate === startDate && propsEndDate === endDate) {
            result = false;
          }
        }

        return result;
      };

      var getReturnDate = function getReturnDate(item, dateType) {
        var returnDate = item;

        if (useTimeStamp) {
          if (timePicker) {
            returnDate = new Date((0, _index.formatDateString)(item)).getTime();
          } else {
            if (dateType === 'endDate') {
              returnDate = new Date((0, _index.formatDateString)("".concat(item, " 23:59:59"))).getTime();
            } else {
              returnDate = new Date((0, _index.formatDateString)("".concat(item, " 00:00:00"))).getTime();
            }
          }
        }

        return returnDate;
      };

      var result = '';
      var startDate = '';
      var endDate = '';

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (type === 'clear') {
          // 清空
          if (propsType === 'single') {
            if (fixedNumber) {
              onChange(event, '', '');
            } else {
              onChange(event, '');
            }
          } else {
            if (needTriggerChange('', '')) {
              onChange(event, '', '');
            }
          }
        } else {
          if (data) {
            // 单日期
            if ((0, _spauiUtils.isObject)(data) && data.year) {
              result = (0, _spauiUtils.joinDate)(data, format);
            }

            if (needTriggerChange(result)) {
              var selectDate = getReturnDate(result, 'single');

              if (picker === 'week') {
                if (fixedNumber) {
                  var disableWeekDays = data.disableWeekDays;

                  if (fixedNumber > 0) {
                    startDate = selectDate;
                    endDate = (0, _index.getLastWeekByNumber)(selectDate, fixedNumber);
                  } else {
                    startDate = (0, _index.getLastWeekByNumber)(selectDate, fixedNumber);
                    endDate = selectDate;
                  }

                  if (endDate > maxDate) {
                    endDate = maxDate; // 最大日期后一天边界加入

                    disableWeekDays.push((0, _index.formatDate)(new Date(endDate).getTime() + 1 * 24 * 3600 * 1000));
                  }

                  if (startDate < minDate) {
                    startDate = minDate; // 把最小日期边界前一天加入

                    disableWeekDays.push((0, _index.formatDate)(new Date(startDate).getTime() - 1 * 24 * 3600 * 1000));
                  }

                  this.triggerWeekChange(event, onChange, getReturnDate, startDate, endDate, firstDayOfWeek, endDayOfWeek, disableWeekDays);
                } else {
                  var selectWeek = {
                    // 返回选择周信息
                    text: "".concat((0, _index.getWeekOfYearByDate)(selectDate, firstDayOfWeek, endDayOfWeek), "\u5468"),
                    // 返回选择周内所有的天数
                    value: {
                      // 全部天数，包含不可选日期
                      all: (0, _index.uniqueArray)((0, _index.getCurrentWeekDays)(selectDate, firstDayOfWeek, endDayOfWeek)),
                      // 部分天数，不包含不可选日期
                      part: (0, _index.uniqueArray)((0, _index.getCurrentWeekDays)(selectDate, firstDayOfWeek, endDayOfWeek, data.disableWeekDays))
                    }
                  };
                  onChange(event, selectDate, selectWeek);
                }
              } else {
                onChange(event, getReturnDate(result, 'single'));
              }
            }
          } else if (startData || endData) {
            // 双日期
            if ((0, _spauiUtils.isObject)(startData) && startData.year) {
              startDate = (0, _spauiUtils.joinDate)(startData, format);
            } // 是否无限日期


            if (startDateCanBeUnlimited && startDate === this.getDateValue('startDate', unlimitedDateValue)) {
              startDate = unlimitedDateValue;
            }

            if ((0, _spauiUtils.isObject)(endData) && endData.year) {
              endDate = (0, _spauiUtils.joinDate)(endData, format);
            } // 是否无限日期


            if (endDateCanBeUnlimited && endDate === this.getDateValue('endDate', unlimitedDateValue)) {
              endDate = unlimitedDateValue;
            } // 如果是无限日期，那就直接返回咯


            if ((startData || typeof startData === 'number') && startData === unlimitedDateValue) {
              startDate = startData;
            }

            if ((endData || typeof endData === 'number') && endData === unlimitedDateValue) {
              endDate = endData;
            }

            if (needTriggerChange(startDate, endDate)) {
              if (picker === 'week') {
                if (fixedNumber) {
                  if (fixedNumber > 0) {
                    endDate = (0, _index.getLastWeekByNumber)(startDate, fixedNumber);
                  } else {
                    startDate = (0, _index.getLastWeekByNumber)(endDate, fixedNumber);
                  }

                  if (endDate > maxDate) {
                    endDate = maxDate;
                  }

                  if (startDate < minDate) {
                    startDate = minDate;
                  }
                }

                var startDisableDays = startData.disableWeekDays && startData.disableWeekDays.length > 0 ? startData.disableWeekDays : [];
                var endDisableDays = endData.disableWeekDays && endData.disableWeekDays.length > 0 ? endData.disableWeekDays : [];

                var _disableWeekDays = startDisableDays.concat(endDisableDays).concat((0, _index.getHideWeekDays)(startDate, endDate, firstDayOfWeek, endDayOfWeek));

                this.triggerWeekChange(event, onChange, getReturnDate, startDate, endDate, firstDayOfWeek, endDayOfWeek, _disableWeekDays);
              } else {
                onChange(event, getReturnDate(startDate, 'startDate'), getReturnDate(endDate, 'endDate'));
              }
            }
          }
        }
      }
    } // 面板打开响应函数

  }, {
    key: "handleOpen",
    value: function handleOpen(event) {
      var _compactProps4 = (0, _datepicker_compact_props["default"])(this.props),
          propsOpen = _compactProps4.open,
          disabled = _compactProps4.disabled,
          type = _compactProps4.type,
          startDateDisabled = _compactProps4.startDateDisabled,
          endDateDisabled = _compactProps4.endDateDisabled,
          onOpen = _compactProps4.onOpen;

      var open = this.state.open;
      var result = false; // 禁用的时候没法打开

      if (!disabled && !(type === 'range' && startDateDisabled && endDateDisabled)) {
        // 如果没传open，就需要内部维护一个状态
        if ((0, _spauiUtils.isUndefined)(propsOpen)) {
          result = !open;
          this.setState({
            open: result
          });
        } else {
          result = !propsOpen;
        } // 关闭的话，展示值状态重置


        if (!result) {
          this.setState(_objectSpread({}, this.getDataByPropsDate((0, _datepicker_compact_props["default"])(this.props))));
        }

        if ((0, _spauiUtils.isFunction)(onOpen)) {
          onOpen(event, result);
        }
      }
    } // 获得下拉面板的位置样式，主要依据方向与偏移量

  }, {
    key: "getDropDownStyle",
    value: function getDropDownStyle() {
      var _compactProps5 = (0, _datepicker_compact_props["default"])(this.props),
          horizontalPosition = _compactProps5.horizontalPosition,
          verticalPosition = _compactProps5.verticalPosition,
          positionSetByCss = _compactProps5.positionSetByCss,
          _compactProps5$positi = _compactProps5.positionDeviation,
          positionDeviation = _compactProps5$positi === void 0 ? {} : _compactProps5$positi;

      var result = {};

      if (!positionSetByCss) {
        switch (horizontalPosition) {
          case 'right':
            result.left = "".concat(positionDeviation.left || 0, "px");
            result.right = 'auto';
            break;

          case 'left':
            result.left = 'auto';
            result.right = "".concat(positionDeviation.right || 0, "px");
            break;
        }

        switch (verticalPosition) {
          case 'top':
            result.bottom = "".concat(positionDeviation.bottom || 0, "px");
            result.top = 'auto';
            break;

          case 'bottom':
            result.bottom = 'auto';
            result.top = "".concat(positionDeviation.top || 0, "px");
            break;
        }
      } // css自带有的样式，js删除


      if (result.top === '0px' && result.bottom === 'auto') {
        delete result.top;
        delete result.bottom;
      }

      if (result.left === '0px' && result.right === 'auto') {
        delete result.left;
        delete result.right;
      }

      return result;
    } // 可选时间转换

  }, {
    key: "getOptionalTime",
    value: function getOptionalTime(props) {
      var _compactProps6 = (0, _datepicker_compact_props["default"])(props || this.props),
          optionalStartRelativeDays = _compactProps6.optionalStartRelativeDays,
          optionalEndRelativeDays = _compactProps6.optionalEndRelativeDays,
          optionalStartDate = _compactProps6.optionalStartDate,
          optionalEndDate = _compactProps6.optionalEndDate,
          _compactProps6$option = _compactProps6.optionalReferenceTime,
          optionalReferenceTime = _compactProps6$option === void 0 ? '' : _compactProps6$option,
          fulfilStartDateAndRelativeDays = _compactProps6.fulfilStartDateAndRelativeDays,
          fulfilEndDateAndRelativeDays = _compactProps6.fulfilEndDateAndRelativeDays;

      var startDate = null;
      var endDate = null;
      var optionalStartDateData = {};
      var optionalEndDateData = {};
      var referenceDate = null; // 相对时间默认是今天，也可以指定，比如2019/01/01

      if (!optionalReferenceTime) {
        referenceDate = this.currentTime;
      } else {
        referenceDate = new Date(optionalReferenceTime);
      } // 目前可选时间都是以0点为准的


      referenceDate = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate()); // 计算可选的开始时间

      if (fulfilStartDateAndRelativeDays && !(0, _spauiUtils.isUndefined)(optionalStartDate) && !(0, _spauiUtils.isUndefined)(optionalStartRelativeDays)) {
        var absoluteStartDate = new Date(optionalStartDate);
        var relativeStartDate = new Date(referenceDate.getTime() + (0, _index.toInt)(optionalStartRelativeDays) * _data.ONE_DAY_TIME);

        if (absoluteStartDate.valueOf() < relativeStartDate.valueOf()) {
          startDate = relativeStartDate;
        } else {
          startDate = absoluteStartDate;
        }
      } else if (!(0, _spauiUtils.isUndefined)(optionalStartDate)) {
        startDate = new Date(optionalStartDate);
      } else if (!(0, _spauiUtils.isUndefined)(optionalStartRelativeDays)) {
        startDate = new Date(referenceDate.getTime() + (0, _index.toInt)(optionalStartRelativeDays) * _data.ONE_DAY_TIME);
      } // 有开始时间，顺便转化成可选数据时间


      if (startDate) {
        optionalStartDateData = {
          year: startDate.getFullYear(),
          month: startDate.getMonth(),
          date: startDate.getDate(),
          hour: startDate.getHours(),
          minute: startDate.getMinutes(),
          second: startDate.getSeconds()
        };
      } // 计算可选的结束时间


      if (fulfilEndDateAndRelativeDays && !(0, _spauiUtils.isUndefined)(optionalEndDate) && !(0, _spauiUtils.isUndefined)(optionalEndRelativeDays)) {
        var absoluteEndDate = new Date(optionalEndDate);
        var relativeEndDate = new Date(referenceDate.getTime() + (0, _index.toInt)(optionalEndRelativeDays) * _data.ONE_DAY_TIME);

        if (absoluteEndDate.valueOf() < relativeEndDate.valueOf()) {
          endDate = absoluteEndDate;
        } else {
          endDate = relativeEndDate;
        }
      } else if (!(0, _spauiUtils.isUndefined)(optionalEndDate)) {
        endDate = new Date(optionalEndDate);
      } else if (!(0, _spauiUtils.isUndefined)(optionalEndRelativeDays)) {
        endDate = new Date(referenceDate.getTime() + (0, _index.toInt)(optionalEndRelativeDays) * _data.ONE_DAY_TIME);
      }

      if (endDate) {
        optionalEndDateData = {
          year: endDate.getFullYear(),
          month: endDate.getMonth(),
          date: endDate.getDate(),
          hour: endDate.getHours(),
          minute: endDate.getMinutes(),
          second: endDate.getSeconds()
        }; // 如果时分秒都是0就不限制

        if (optionalEndDateData.hour === 0 && optionalEndDateData.minute === 0 && optionalEndDateData.second === 0) {
          delete optionalEndDateData.hour;
          delete optionalEndDateData.minute;
          delete optionalEndDateData.second;
        }
      }

      return {
        startDate: startDate,
        endDate: endDate,
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData
      };
    } // 是不是无限日期

  }, {
    key: "isUnlimitedDate",
    value: function isUnlimitedDate() {
      var dateValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var props = arguments.length > 1 ? arguments[1] : undefined;

      var _compactProps7 = (0, _datepicker_compact_props["default"])(props || this.props || {}),
          unlimitedDateValue = _compactProps7.unlimitedDateValue;

      return (dateValue || typeof dateValue === 'number') && dateValue === unlimitedDateValue;
    } // 获取日期（如果是无限日期就设置为当前日期的1000年后）

  }, {
    key: "getDateValue",
    value: function getDateValue() {
      var dateType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var dateValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var props = arguments.length > 2 ? arguments[2] : undefined;

      var _compactProps8 = (0, _datepicker_compact_props["default"])(props || this.props || {}),
          format = _compactProps8.format;

      var currentTimeStamp = this.currentTime.getTime();
      var result = '';
      var theDate = {};

      if (this.isUnlimitedDate(dateValue, props)) {
        // 是开始日期的话，那就是过去1000年
        if (dateType === 'startDate') {
          theDate = new Date(currentTimeStamp - 1000 * 60 * 60 * 24 * 365 * 1000);
        } else {
          theDate = new Date(currentTimeStamp + 1000 * 60 * 60 * 24 * 365 * 1000);
        }

        result = (0, _spauiUtils.joinDate)({
          year: theDate.getFullYear(),
          month: theDate.getMonth(),
          date: theDate.getDate(),
          hour: theDate.getHours(),
          minute: theDate.getMinutes(),
          second: theDate.getSeconds()
        }, format);
      } else {
        result = dateValue;
      }

      return result;
    } // 获取字符串类型的日期文案

  }, {
    key: "getLabel",
    value: function getLabel() {
      var useState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$state = this.state,
          _this$state$dateData = _this$state.dateData,
          dateData = _this$state$dateData === void 0 ? {} : _this$state$dateData,
          _this$state$startDate = _this$state.startDateData,
          startDateData = _this$state$startDate === void 0 ? {} : _this$state$startDate,
          _this$state$endDateDa = _this$state.endDateData,
          endDateData = _this$state$endDateDa === void 0 ? {} : _this$state$endDateDa;

      var _compactProps9 = (0, _datepicker_compact_props["default"])(this.props),
          placeholder = _compactProps9.placeholder,
          propsDate = _compactProps9.date,
          propsStartDate = _compactProps9.startDate,
          propsEndDate = _compactProps9.endDate,
          type = _compactProps9.type,
          format = _compactProps9.format,
          showFormat = _compactProps9.showFormat,
          unlimitedDateValue = _compactProps9.unlimitedDateValue,
          unlimitedDateValueLabel = _compactProps9.unlimitedDateValueLabel,
          startDateCanBeUnlimited = _compactProps9.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _compactProps9.endDateCanBeUnlimited;

      var labelFormat = showFormat || format;
      var date = '';
      var startDate = '';
      var endDate = '';
      var result = ''; // 如果使用state，就根据object的日期合成字符串的日期

      if (useState) {
        date = (0, _spauiUtils.joinDate)(dateData, labelFormat);
        startDate = (0, _spauiUtils.joinDate)(startDateData, labelFormat);
        endDate = (0, _spauiUtils.joinDate)(endDateData, labelFormat);
      } else {
        date = (0, _spauiUtils.joinDate)((0, _spauiUtils.splitDate)(propsDate, format), labelFormat);
        startDate = (0, _spauiUtils.joinDate)((0, _spauiUtils.splitDate)(propsStartDate, format), labelFormat);
        endDate = (0, _spauiUtils.joinDate)((0, _spauiUtils.splitDate)(propsEndDate, format), labelFormat);
      }

      if (type === 'single') {
        if (date) {
          result = date;
        } else {
          result = placeholder;
        }
      } else if (type === 'range') {
        if (startDate || endDate) {
          // 如果是无限日期就替换为无限日期文案
          if (startDateCanBeUnlimited && (this.isUnlimitedDate(propsStartDate) || propsStartDate === this.getDateValue('startDate', unlimitedDateValue))) {
            result = unlimitedDateValueLabel;
          } else {
            result = startDate;
          } // 如果是无限日期就替换为无限日期文案


          if (endDateCanBeUnlimited && (this.isUnlimitedDate(propsEndDate) || propsEndDate === this.getDateValue('endDate', unlimitedDateValue))) {
            // 如果日期的格式是2019-02-01为避免混淆，中间就是用至，其他就是-
            if (startDate.indexOf('-') > -1) {
              result += " ".concat(this.locale.separateLabel, " ");
            } else {
              result += ' - ';
            }

            result += unlimitedDateValueLabel;
          } else {
            if (!this.canUseOneDate() || endDate) {
              // 如果日期的格式是2019-02-01为避免混淆，中间就是用至，其他就是-
              if (startDate.indexOf('-') > -1) {
                result += " ".concat(this.locale.separateLabel, " ");
              } else {
                result += ' - ';
              }
            }

            result += endDate;
          }
        } else {
          result = placeholder;
        }
      }

      return result;
    } // 根据props的信息，将date, startDate, endDate转行成展示的元数据

  }, {
    key: "getDataByPropsDate",
    value: function getDataByPropsDate(currentProps) {
      var returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var statusType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var props = (0, _datepicker_compact_props["default"])(currentProps || this.props || {});
      var _props$date = props.date,
          date = _props$date === void 0 ? '' : _props$date,
          _props$startDate = props.startDate,
          startDate = _props$startDate === void 0 ? '' : _props$startDate,
          _props$endDate = props.endDate,
          endDate = _props$endDate === void 0 ? '' : _props$endDate,
          type = props.type,
          format = props.format,
          _props$hideEndDatePan = props.hideEndDatePanel,
          hideEndDatePanel = _props$hideEndDatePan === void 0 ? false : _props$hideEndDatePan,
          picker = props.picker,
          defaultShowDatePosition = props.defaultShowDatePosition;

      var _this$getOptionalTime4 = this.getOptionalTime(props),
          optionalStartDateObject = _this$getOptionalTime4.startDate,
          optionalEndDateObject = _this$getOptionalTime4.endDate;

      var currentTimeStamp = this.currentTime.getTime();
      var currentTime = null; // 如果今天不在可选日期范围内，就以可选日期为开始日期
      // 结束日期需要加多一天，因为默认获取到的是今天0点的，会比现在的小

      if (defaultShowDatePosition === 'start') {
        currentTime = optionalStartDateObject;
      } else if (defaultShowDatePosition === 'end') {
        currentTime = optionalEndDateObject;
      } else {
        if (currentTimeStamp < optionalStartDateObject.getTime() || currentTimeStamp > optionalEndDateObject.getTime() + 24 * 60 * 60 * 1000) {
          currentTime = optionalStartDateObject;
        } else {
          currentTime = this.currentTime;
        }
      } // 当前的时间


      var nowYear = currentTime.getFullYear();
      var nowMonth = currentTime.getMonth();
      var nowMonthFirstDate = new Date(nowYear, nowMonth, 1);
      var nowMonthLastDate = new Date(nowYear, nowMonth, new Date(nowYear, nowMonth, 0).getDate());
      var dateData = {};
      var year = nowYear;
      var month = nowMonth;
      var startDateData = {};
      var startYear = nowYear;
      var startMonth = nowMonth;
      var endDateData = {};
      var endYear = nowYear;
      var endMonth = nowMonth;
      var result = {};
      var comparentMonthData = {};

      if (type === 'single') {
        if (!(0, _spauiUtils.isUndefined)(date) && date) {
          dateData = (0, _spauiUtils.splitDate)(date, format);
          year = dateData.year;
          month = dateData.month;
        }
      } else if (type === 'range') {
        // 默认的显示月份面板逻辑
        if (optionalStartDateObject.getTime() < currentTimeStamp && optionalEndDateObject.getTime() < currentTimeStamp) {
          // 可选的开始时间和结束时间都小于当前时间，那第一个面板就是最后一个可选日期的月份
          endYear = optionalEndDateObject.getFullYear();
          endMonth = optionalEndDateObject.getMonth();

          if (endMonth === 0) {
            startYear = endYear - 1;
            startMonth = 11;
          } else {
            startYear = endYear;
            startMonth = endMonth - 1;
          }
        } else if (Math.abs(optionalEndDateObject.getTime() - nowMonthLastDate.getTime()) > Math.abs(optionalStartDateObject.getTime() - nowMonthFirstDate.getTime())) {
          // 可选的结束时间距离本月末的距离比可选的开始时间距离本月初的距离远，那第一个面板就是本月
          if (nowMonth === 11) {
            endYear = nowYear + 1;
            endMonth = 0;
          } else {
            endYear = nowYear;
            endMonth = nowMonth + 1;
          }
        } else {
          // 如果隐藏了结束面板，默认就是用的当前年月
          if (!hideEndDatePanel) {
            if (nowMonth === 0) {
              startYear = nowYear - 1;
              startMonth = 11;
            } else {
              startYear = nowYear;
              startMonth = nowMonth - 1;
            }
          }
        } // 有开始日期，展示面板要用开始日期


        if (!(0, _spauiUtils.isUndefined)(startDate) && startDate) {
          startDateData = (0, _spauiUtils.splitDate)(this.getDateValue('startDate', startDate, props), format);
          startYear = startDateData.year;
          startMonth = startDateData.month;
        } // 有结束日期，展示面板要用结束日期


        if (!(0, _spauiUtils.isUndefined)(endDate) && endDate) {
          endDateData = (0, _spauiUtils.splitDate)(this.getDateValue('endDate', endDate, props), format);
          endYear = endDateData.year;
          endMonth = endDateData.month;
        } // 如果是无限日期的话，要调整下展示面板，毕竟无限日期是个假内容


        if (this.isUnlimitedDate(startDate, props) && !this.isUnlimitedDate(endDate, props)) {
          startYear = endYear;
          startMonth = endMonth;
        } else if (!this.isUnlimitedDate(startDate, props) && this.isUnlimitedDate(endDate, props)) {
          endYear = startYear;
          endMonth = startMonth;
        } else if (this.isUnlimitedDate(startDate, props) && this.isUnlimitedDate(endDate, props)) {
          startYear = nowYear;
          startMonth = nowMonth;
          endYear = startYear;
          endMonth = startMonth;
        } // 确保左边的年月跟右边的年月不一致
        // 隐藏结束面板的话就不需要对比了


        if (!hideEndDatePanel) {
          comparentMonthData = this.comparentMonth(startYear, startMonth, endYear, endMonth);
          startYear = comparentMonthData.startYear;
          startMonth = comparentMonthData.startMonth;
          endYear = comparentMonthData.endYear;
          endMonth = comparentMonthData.endMonth;
        } // 没有隐藏面板，两个日期都在左边面板，右边面板不在可选日期内，那就把右边面板设置为此时左边面板的日期


        if (!hideEndDatePanel && startDateData.year === startYear && startDateData.month === startMonth && endDateData.year === startYear && endDateData.month === startMonth && (new Date(endYear, endMonth, 1).getTime() < optionalStartDateObject.getTime() || new Date(endYear, endMonth, 1).getTime() > optionalEndDateObject.getTime())) {
          endYear = startYear;
          endMonth = startMonth;
          startMonth = startMonth - 1;

          if (startMonth < 0) {
            startYear = startYear - 1;
            startMonth = startMonth + 12;
          }
        }
      } // 根据需要返回对应的数据


      if (returnType === 'single') {
        result = {
          dateData: dateData,
          year: year,
          month: month
        };
      } else if (returnType === 'start') {
        result = {
          startDateData: startDateData,
          startYear: startYear,
          startMonth: startMonth
        };
      } else if (returnType === 'end') {
        result = {
          endDateData: endDateData,
          endYear: endYear,
          endMonth: endMonth
        };
      } else {
        if (picker === 'month' && type === 'range' && statusType === 'init') {
          result = {
            dateData: dateData,
            startDateData: startDateData,
            startYear: startYear,
            endDateData: endDateData,
            endYear: endYear
          };
        } else {
          result = {
            dateData: dateData,
            year: year,
            month: month,
            startDateData: startDateData,
            startYear: startYear,
            startMonth: startMonth,
            endDateData: endDateData,
            endYear: endYear,
            endMonth: endMonth
          };
        }
      }

      return result;
    } // 获得快捷日期配置

  }, {
    key: "getShortcuts",
    value: function getShortcuts() {
      var _compactProps10 = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps10$type = _compactProps10.type,
          type = _compactProps10$type === void 0 ? '' : _compactProps10$type,
          shortcuts = _compactProps10.shortcuts;

      var result = [];

      if (typeof shortcuts === 'undefined') {
        // 单日期与双日期的快捷配置不一样
        if (type === 'single') {
          result = (0, _data.getSingleDefaultShortCuts)(this.locale);
        } else {
          result = (0, _data.getRangeDefaultShortcuts)(this.locale);
        }
      } else {
        result = shortcuts;
      }

      return result;
    } // 展示区域清空

  }, {
    key: "handleClear",
    value: function handleClear(event) {
      this.triggerChange(event, 'clear');
    } // 实时显示选择的日期

  }, {
    key: "handleRealtimeChange",
    value: function handleRealtimeChange(event, type) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _compactProps11 = (0, _datepicker_compact_props["default"])(this.props),
          onInputChange = _compactProps11.onInputChange,
          format = _compactProps11.format;

      var result = {};

      if (type === 'single') {
        this.setState({
          dateData: data,
          empty: false
        }); // 通过onInputChange可以获得实时选择的信息

        if ((0, _spauiUtils.isFunction)(onInputChange)) {
          onInputChange(event, (0, _spauiUtils.joinDate)(data, format));
        }
      } else {
        result.empty = false;

        if (typeof data.startData !== 'undefined') {
          result.startDateData = data.startData;
        }

        if (typeof data.endData !== 'undefined') {
          result.endDateData = data.endData;
        }

        this.setState(result);

        if ((0, _spauiUtils.isFunction)(onInputChange)) {
          onInputChange(event, data.startData && (0, _spauiUtils.joinDate)(data.startData, format), data.endData && (0, _spauiUtils.joinDate)(data.endData, format));
        }
      }
    } // 单日期数据变更

  }, {
    key: "handleSingleChange",
    value: function handleSingleChange(event, type, data) {
      this.triggerChange(event, type, {
        data: data
      });
      this.handleOpen(event);
    } // 双日期数据变更

  }, {
    key: "handleRangeChange",
    value: function handleRangeChange(event, startData, endData) {
      var _compactProps12 = (0, _datepicker_compact_props["default"])(this.props),
          type = _compactProps12.type;

      this.triggerChange(event, type, {
        startData: startData,
        endData: endData
      });
      this.handleOpen(event);
    } // 确保左边的年月跟右边的年月不一致

  }, {
    key: "comparentMonth",
    value: function comparentMonth(_startYear, _startMonth, _endYear, _endMonth) {
      var _compactProps13 = (0, _datepicker_compact_props["default"])(this.props),
          endDateDisabled = _compactProps13.endDateDisabled,
          picker = _compactProps13.picker;

      var startYear = _startYear;
      var startMonth = _startMonth;
      var endYear = _endYear;
      var endMonth = _endMonth; // 如果两个月份一模一样的话，就要排除一样

      if (startYear === endYear && startMonth === endMonth && picker === 'date') {
        // 右边面板被禁用了，就让左边面板小一个月
        if (endDateDisabled) {
          startMonth = startMonth - 1;

          if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
          }
        } else {
          // 默认右边面板比左边面板大1个月
          endMonth = endMonth + 1;

          if (endMonth > 11) {
            endMonth -= 12;
            endYear += 1;
          }
        }
      } // 如果是选择月份的话，排除年份面板一样的情况


      if (startYear === endYear && picker === 'month') {
        // 右边面板被禁用了，就让左边面板小一年月
        if (endDateDisabled) {
          startYear = startYear - 1;
        } else {
          // 默认右边面板比左边面板大1年
          endYear = endYear + 1;
        }
      }

      return {
        startYear: startYear,
        startMonth: startMonth,
        endYear: endYear,
        endMonth: endMonth
      };
    } // 展示的月份面板变更

  }, {
    key: "handleYearAndMonthChange",
    value: function handleYearAndMonthChange(event, theType, theYear, theMonth, callback) {
      var _compactProps14 = (0, _datepicker_compact_props["default"])(this.props),
          startDateDisabled = _compactProps14.startDateDisabled,
          endDateDisabled = _compactProps14.endDateDisabled;

      var _this$state2 = this.state,
          startYear = _this$state2.startYear,
          startMonth = _this$state2.startMonth,
          endYear = _this$state2.endYear,
          endMonth = _this$state2.endMonth;

      var _this$getOptionalTime5 = this.getOptionalTime(),
          _this$getOptionalTime6 = _this$getOptionalTime5.optionalStartDateData,
          optionalStartDateData = _this$getOptionalTime6 === void 0 ? {} : _this$getOptionalTime6,
          _this$getOptionalTime7 = _this$getOptionalTime5.optionalEndDateData,
          optionalEndDateData = _this$getOptionalTime7 === void 0 ? {} : _this$getOptionalTime7;

      var year = theYear;
      var type = theType;
      var month = theMonth; // 限制月份，月份不能超过可选月份

      if (year === optionalEndDateData.year && month > optionalEndDateData.month) {
        month = optionalEndDateData.month;
      } else if (year === optionalStartDateData.year && month < optionalStartDateData.month) {
        month = optionalStartDateData.month;
      } // 如果点击的是禁用的面板，且要切换月份，那就让另外一个没有禁用的切换（主要是点击上下月份的日期的时候）


      if (type === 'start' && startDateDisabled && !endDateDisabled && month !== startMonth) {
        type = 'end';
      } else if (type === 'end' && !startDateDisabled && endDateDisabled && month !== endMonth) {
        type = 'start';
      }

      if (type === 'start') {
        this.setState(_objectSpread({}, this.comparentMonth(year, month, endYear, endMonth)), callback);
      } else if (type === 'end') {
        this.setState(_objectSpread({}, this.comparentMonth(startYear, startMonth, year, month)), callback);
      } else if (type === 'single') {
        this.setState({
          year: year,
          month: month
        });
      }
    } // 获取双日期时分秒的列表数据

  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';

      var _compactProps15 = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps15$start = _compactProps15.startTimePickerProps,
          startTimePickerProps = _compactProps15$start === void 0 ? {} : _compactProps15$start,
          endTimePickerProps = _compactProps15.endTimePickerProps;

      var startTimeList = startTimePickerProps.timeList;
      var endTimeList = endTimePickerProps.timeList;
      var i = 0;
      var result = null; // 如果不为undefined，就优先用传的参数

      if (type === 'start' && !(0, _spauiUtils.isUndefined)(startTimeList)) {
        result = startTimeList || [];
      } else if (type === 'end' && !(0, _spauiUtils.isUndefined)(endTimeList)) {
        result = endTimeList || [];
      } else {
        result = [];

        for (; i < 24; i++) {
          result.push("".concat((0, _index.addZero)(i), ":00"));
          result.push("".concat((0, _index.addZero)(i), ":30"));
        }
      }

      return result;
    } // 对于不使用时分秒、没隐藏确定按钮、可以选择当天的，选择一个日期后，就可以确定按钮了

  }, {
    key: "canUseOneDate",
    value: function canUseOneDate() {
      var _compactProps16 = (0, _datepicker_compact_props["default"])(this.props),
          timePicker = _compactProps16.timePicker,
          hideSubmitButton = _compactProps16.hideSubmitButton,
          _compactProps16$short = _compactProps16.shortestRange,
          shortestRange = _compactProps16$short === void 0 ? 0 : _compactProps16$short,
          _compactProps16$start = _compactProps16.startDateDisabled,
          startDateDisabled = _compactProps16$start === void 0 ? false : _compactProps16$start,
          _compactProps16$endDa = _compactProps16.endDateDisabled,
          endDateDisabled = _compactProps16$endDa === void 0 ? false : _compactProps16$endDa,
          disabled = _compactProps16.disabled,
          _compactProps16$canCh = _compactProps16.canChooseOneDateByRange,
          canChooseOneDateByRange = _compactProps16$canCh === void 0 ? true : _compactProps16$canCh,
          _compactProps16$type = _compactProps16.type,
          type = _compactProps16$type === void 0 ? '' : _compactProps16$type,
          _compactProps16$endDa2 = _compactProps16.endDateCanBeUnlimited,
          endDateCanBeUnlimited = _compactProps16$endDa2 === void 0 ? false : _compactProps16$endDa2;

      var result = false;

      if (type === 'range' && !timePicker && !hideSubmitButton && shortestRange == 0 && !endDateDisabled && !startDateDisabled && !disabled && canChooseOneDateByRange && !endDateCanBeUnlimited) {
        result = true;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this,
          _classNames2;

      var _compactProps17 = (0, _datepicker_compact_props["default"])(this.props),
          type = _compactProps17.type,
          picker = _compactProps17.picker,
          bodyDropDownClassName = _compactProps17.bodyDropDownClassName,
          ValueAreaComponent = _compactProps17.ValueAreaComponent,
          disabled = _compactProps17.disabled,
          startDateDisabled = _compactProps17.startDateDisabled,
          endDateDisabled = _compactProps17.endDateDisabled,
          mountTarget = _compactProps17.mountTarget,
          timePicker = _compactProps17.timePicker,
          timePickerProps = _compactProps17.timePickerProps,
          startTimePickerProps = _compactProps17.startTimePickerProps,
          endTimePickerProps = _compactProps17.endTimePickerProps,
          _compactProps17$hideE = _compactProps17.hideEndDatePanel,
          hideEndDatePanel = _compactProps17$hideE === void 0 ? false : _compactProps17$hideE,
          hideNoCurrentMonthDate = _compactProps17.hideNoCurrentMonthDate,
          setLabel = _compactProps17.setLabel,
          useShortcut = _compactProps17.useShortcut,
          useNewUI = _compactProps17.useNewUI,
          transitionName = _compactProps17.transitionName,
          endDayOfWeek = _compactProps17.endDayOfWeek;

      var _this$state3 = this.state,
          _this$state3$dateData = _this$state3.dateData,
          dateData = _this$state3$dateData === void 0 ? {} : _this$state3$dateData,
          _this$state3$startDat = _this$state3.startDateData,
          startDateData = _this$state3$startDat === void 0 ? {} : _this$state3$startDat,
          _this$state3$endDateD = _this$state3.endDateData,
          endDateData = _this$state3$endDateD === void 0 ? {} : _this$state3$endDateD,
          year = _this$state3.year,
          month = _this$state3.month,
          startYear = _this$state3.startYear,
          startMonth = _this$state3.startMonth,
          endYear = _this$state3.endYear,
          endMonth = _this$state3.endMonth,
          open = _this$state3.open,
          empty = _this$state3.empty;
      var classNameMap = this.getClassNameMap(); // 最外一层的className

      var className = (0, _classnames["default"])(this.props.className, (_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerHideNoCurrentMonthDateClassName, hideNoCurrentMonthDate), _defineProperty(_classNames, classNameMap.DatePicker, true), _defineProperty(_classNames, classNameMap.DatePickerRangeClassName, type === 'range'), _defineProperty(_classNames, classNameMap.DatePickerRangeButSinglePanelClassName, type === 'range' && hideEndDatePanel), _defineProperty(_classNames, classNameMap.DatePickerRangeAndTimePickerClassName, type === 'range' && timePicker), _defineProperty(_classNames, classNameMap.DatePickerOpenClassName, open), _defineProperty(_classNames, classNameMap.DateTimePicker, useNewUI), _classNames)); // 可选时间

      var _this$getOptionalTime8 = this.getOptionalTime(),
          optionalStartDateData = _this$getOptionalTime8.optionalStartDateData,
          optionalEndDateData = _this$getOptionalTime8.optionalEndDateData,
          optionalStartDateObject = _this$getOptionalTime8.startDate,
          optionalEndDateObject = _this$getOptionalTime8.endDate; // 透传给下一层组件的公共参数


      var commonProps = {
        picker: picker,
        open: open,
        onOpen: this.handleOpen,
        shortcuts: this.getShortcuts(),
        nowDateObject: this.currentTime,
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData,
        optionalStartDateObject: optionalStartDateObject,
        optionalEndDateObject: optionalEndDateObject,
        timePickerProps: timePicker ? timePickerProps : {},
        startTimePickerProps: timePicker ? _objectSpread({
          timeList: this.getTimeList('start')
        }, startTimePickerProps) : {},
        endTimePickerProps: timePicker ? _objectSpread({
          timeList: this.getTimeList('end')
        }, endTimePickerProps) : {},
        canChooseOneDateByRange: this.canUseOneDate(),
        locale: this.locale,
        setLabel: setLabel
      };

      if (startTimePickerProps && startTimePickerProps.config && startTimePickerProps.config.hour && startTimePickerProps.config.minute && startTimePickerProps.config.second) {
        delete commonProps.startTimePickerProps.timeList;
      }

      if (endTimePickerProps && endTimePickerProps.config && endTimePickerProps.config.hour && endTimePickerProps.config.minute && endTimePickerProps.config.second) {
        delete commonProps.endTimePickerProps.timeList;
      }

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {}, DatePicker), {
        className: className,
        onClick: function onClick() {
          // 如果已经监听了空白处点击，要告诉这是内部点击
          if (_this2.haveDocumentClick) {
            _this2._insideClick = true;
            _this2._inputDateTriggerBlur = false;
          }
        },
        ref: function ref(el) {
          _this2.domRef = el;
        }
      }), _react["default"].createElement(ValueAreaComponent, _extends({}, (0, _datepicker_compact_props["default"])(this.props), commonProps, {
        picker: picker,
        classNameMap: this.getClassNameMap(),
        label: this.getLabel(),
        disabled: type === 'range' && startDateDisabled && endDateDisabled || disabled,
        onClear: this.handleClear,
        triggerChange: this.triggerChange
      })), _react["default"].createElement(_odAnimate["default"], {
        transitionName: transitionName,
        component: ""
      }, open ? _react["default"].createElement(_use_portal_component["default"], {
        locale: this.locale,
        setLabel: setLabel,
        target: mountTarget,
        className: className,
        classNameMap: this.getClassNameMap()
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(bodyDropDownClassName, (_classNames2 = {}, _defineProperty(_classNames2, classNameMap.DatePickerDropdownClassName, true), _defineProperty(_classNames2, classNameMap.DatePickerRangeClassName, type === 'range'), _defineProperty(_classNames2, classNameMap.DatePickerRangeButSinglePanelClassName, type === 'range' && hideEndDatePanel), _defineProperty(_classNames2, classNameMap.DatePickerDropdownFastControlClassName, type === 'range'), _defineProperty(_classNames2, classNameMap.DatePickerDropdownTimePickerClassName, timePicker && !useNewUI), _defineProperty(_classNames2, classNameMap.DatePickerDropdownWithLeftFastControlClassName, type === 'range' && useNewUI && useShortcut), _classNames2)),
        style: this.getDropDownStyle(),
        ref: function ref(el) {
          _this2.dropdownRef = el;
        },
        onClick: function onClick() {
          if (_this2.haveDocumentClick) {
            _this2._insideClick = true;
          }
        }
      }, _react["default"].createElement(_date_play_component["default"], _extends({}, (0, _datepicker_compact_props["default"])(this.props), commonProps, {
        picker: picker,
        classNameMap: this.getClassNameMap(),
        getDateValue: this.getDateValue,
        dateData: dateData,
        startDateData: startDateData,
        endDateData: endDateData,
        label: this.getLabel(true),
        disabled: type === 'range' && startDateDisabled && endDateDisabled || disabled,
        triggerChange: this.triggerChange,
        onRealtimeChange: this.handleRealtimeChange,
        onYearAndMonthChange: this.handleYearAndMonthChange,
        ref: function ref(el) {
          _this2.datePlayRef = el;
        },
        elementRef: function elementRef(el) {
          _this2.datePlayElementRef = el;
        },
        onInsideClick: function onInsideClick() {
          if (_this2.haveDocumentClick) {
            _this2._insideClick = true;
          }
        },
        onBlur: function onBlur() {
          _this2._inputDateTriggerBlur = true;
        }
      })), type === 'single' ? _react["default"].createElement(_single_date_component["default"], _extends({}, (0, _datepicker_compact_props["default"])(this.props), commonProps, {
        classNameMap: this.getClassNameMap(),
        empty: empty,
        onRealtimeChange: this.handleRealtimeChange,
        year: year,
        month: month,
        onChange: this.handleSingleChange,
        dateData: dateData,
        onYearAndMonthChange: this.handleYearAndMonthChange
      })) : null, type === 'range' ? _react["default"].createElement(_range_date_component["default"], _extends({}, (0, _datepicker_compact_props["default"])(this.props), commonProps, {
        classNameMap: this.getClassNameMap(),
        getDateValue: this.getDateValue,
        empty: empty,
        onRealtimeChange: this.handleRealtimeChange,
        startYear: startYear,
        startMonth: startMonth,
        endYear: endYear,
        endMonth: endMonth,
        startData: startDateData,
        endData: endDateData,
        onSubmit: this.handleRangeChange,
        useShortcut: useShortcut && !(picker === 'week' && endDayOfWeek) // 周选择器配置endDayOfWeek屏蔽快捷键
        ,
        onYearAndMonthChange: this.handleYearAndMonthChange
      })) : null)) : null));
    }
  }]);

  return DatePicker;
}(_react.PureComponent); // 组件标记


_defineProperty(DatePicker, "propTypes", _datepicker_props.propTypes);

_defineProperty(DatePicker, "defaultProps", _datepicker_props.defaultProps);

(0, _spauiUtils.setComponentMark)(DatePicker, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = DatePicker;
exports["default"] = _default;